import React from "react";
import TextBlock from "../../NotFound/NotFoundBlock/TextBlock/TextBlock";
import greenTick from "../../../images/green-tick.png";

const SuccessBlock = (props) => {
  return (
    <div className="successBlock rounded-lg p-5 ml-auto mr-auto mt-4 relative">
      <div className="greenTick">
        <img src={greenTick} alt="" />
      </div>
      <div className="flex flex-col">
        <div>
          <TextBlock
            big
            content={props.content}
            customStyle={{ color: "rgba(26,26,26,0.4)" }}
          />
        </div>
      </div>
    </div>
  );
};

export default SuccessBlock;
